var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessageBubbles = function SvgMessageBubbles(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 155,
    viewBox: "0 0 156 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.69,
    clipPath: "url(#clip0_3816_106708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7139 20.0999C11.3331 20.4892 4.04405 28.4093 4.43327 37.7901L5.8652 72.3008C6.25443 81.6816 14.1746 88.9707 23.5554 88.5815L28.4984 88.3764L28.9985 100.43C29.0326 101.252 29.9905 101.683 30.629 101.164L47.2941 87.5965L108.625 85.0517C118.006 84.6625 125.295 76.7424 124.906 67.3616L123.474 32.8508C123.085 23.4701 115.165 16.181 105.784 16.5702L20.7139 20.0999Z",
    fill: "url(#paint0_linear_3816_106708)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2754,
    y: 34.3984,
    width: 95.6281,
    height: 5.27234,
    rx: 2.63617,
    transform: "rotate(-2.37596 15.2754 34.3984)",
    fill: "#8BCAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7129,
    y: 44.9336,
    width: 43.8949,
    height: 5.27234,
    rx: 2.63617,
    transform: "rotate(-2.37596 15.7129 44.9336)",
    fill: "#8BCAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.7031,
    y: 42.9844,
    width: 23.5151,
    height: 5.27234,
    rx: 2.63617,
    transform: "rotate(-2.37596 62.7031 42.9844)",
    fill: "#8BCAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1504,
    y: 55.4688,
    width: 87.7897,
    height: 5.27234,
    rx: 2.63617,
    transform: "rotate(-2.37596 16.1504 55.4688)",
    fill: "#8BCAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.662 74.4587C148.388 74.7792 154.391 81.3017 154.07 89.027L153.034 114.005C152.713 121.73 146.191 127.733 138.465 127.412L135.847 127.304L135.564 134.127C135.495 135.782 133.561 136.641 132.287 135.583L122.719 127.632C122.407 127.373 122.203 127.062 122.092 126.733L76.2926 124.833C68.5673 124.512 62.5645 117.99 62.885 110.264L63.9214 85.2866C64.2419 77.5612 70.7644 71.5585 78.4898 71.879L140.662 74.4587Z",
    fill: "url(#paint1_linear_3816_106708)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72.4184,
    height: 4.07686,
    rx: 2.03843,
    transform: "matrix(0.99914 0.0414562 0.0414562 -0.99914 72.6992 102.922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.2412,
    height: 4.07686,
    rx: 2.03843,
    transform: "matrix(0.99914 0.0414562 0.0414562 -0.99914 73.0352 94.7734)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.8078,
    height: 4.07686,
    rx: 2.03843,
    transform: "matrix(0.99914 0.0414562 0.0414562 -0.99914 108.621 96.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.4824,
    height: 4.07686,
    rx: 2.03843,
    transform: "matrix(0.99914 0.0414562 0.0414562 -0.99914 73.375 86.6289)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3816_106708",
    x1: 49.5691,
    y1: 24.3111,
    x2: 90.6761,
    y2: 106.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3816_106708",
    x1: 109.551,
    y1: 81.4986,
    x2: 106.124,
    y2: 134.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3816_106708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 155)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageBubbles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "message-bubbles.a024a94dd4e4d6242cae0b637324b8d2.svg";